'use client'
import ScrollViewforcasparcg from '../components/ScrollViewforcasparcg';

const Page = () => {
  return (
    <div >
      <ScrollViewforcasparcg />
    </div>
  );
};

export default Page;
